import React, { Component } from "react";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import {
  Row,
  Table,
  Tooltip,
  Button,
  Skeleton,
  Col,
  Modal,
  Divider,
} from "antd";
import searchColumns from "../../../helpers/searchColumns";
import { Link } from "react-router-dom";
import {
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
const moment = require("moment");

class ProcessedLetters extends Component {
  state = {
    letters: [],
    page: 1,
    pageSize: 20,
    pagination: {},
    searchText: "",
    searchedColumn: "",
    student: {},
    studentModal: false,
    studentLoading: false,
    history: [],
    historyLoading: false,
    rejectModal: false,
    rejectionReason: "",
    selectedRow: {},
    unit: "",
    isReadOnly: false,
  };

  componentDidMount() {
    this.checkUnit();
    this.setState({ isReadOnly: this.props.user.info.type === "guest" });
  }

  checkUnit = () => {
    this.setState({ unit: this.props.user.info.unit_id }, () =>
      this.fetchLetters()
    );
  };

  fetchHistory = (requester) => {
    this.setState({ historyLoading: true });
    Axios.get("/requested-letters?requester=" + requester)
      .then((response) => {
        this.setState({
          history: response.data.payload,
          historyLoading: false,
        });
      })
      .catch(() => {
        this.setState({ historyLoading: false });
      });
  };

  fetchLetters = (filters = {}, sorter = {}) => {
    let params = {};
    // if(filters.letters_type) params.letters_type = filters.letters_type[0]
    if (filters.requester) params.requester = filters.requester[0];
    if (sorter.field && sorter.order) {
      params.sort_field = sorter.field;
      params.sort_order = sorter.order === "ascend" ? 1 : -1;
    }

    if (this.props.user.info.type === "operator") {
      params.faculty_id = this.state.unit;
    }

    if (this.props.user.info.type === "prodi") {
      params.major_id = this.state.unit;
    }

    Axios.get("/requested-letters", {
      params: {
        page: this.state.page,
        step: "processed",
        page_size: this.state.pageSize,
        ...params,
      },
    }).then((response) => {
      let { pagination } = this.state;
      pagination.total = response.data.total;
      pagination.pageSize = this.state.pageSize;
      this.setState(
        { letters: response.data.payload, pagination },
        this.getUnits
      );
    });
  };

  getUnits = async () => {
    const letters = this.state.letters.map((letter) => {
      return Axios.get(
        `/units?unit_id=${letter.faculty_id}&major_id=${letter.major_id}`
      )
        .then((response) => {
          return {
            ...letter,
            major: response.data.payload.name,
          };
        })
        .catch((e) => {
          console.error(e);
          return letter;
        });
    });

    Promise.all(letters).then((response) => {
      this.setState({ letters: response });
    });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState(
      {
        pagination: pager,
        page: pager.current,
      },
      () => {
        this.fetchLetters(filters, sorter);
      }
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  toggleStudentModal = () => {
    this.setState({ studentModal: !this.state.studentModal });
  };

  fetchStudent = (nim) => {
    this.toggleStudentModal();
    this.fetchHistory(nim);
    this.setState({ studentLoading: true });
    Axios.get("/users/mahasiswa/" + nim)
      .then((response) => {
        this.setState({ student: response.data, studentLoading: false });
      })
      .catch(() => {
        this.toggleStudentModal();
        this.setState({ studentLoading: false });
      });
  };

  // handleConfirmLetter = (record) => {
  //     Modal.confirm({
  //         title: 'Proses Surat',
  //         content:'Apakah permohonan telah selesai diproses?',
  //         icon: <ExclamationCircleOutlined />,
  //         okText:'Ya',
  //         cancelText:'Tidak',
  //         onOk:()  => this.handleFinishLetter(record),
  //         oncancel: {}
  //     })
  // }

  // handleFinishLetter = (record) => {
  //     record.step = "finished"
  //     record.finished_date = new Date()
  //     const value = record.fields_value.map(field => JSON.stringify(field))
  //     const responseValue = record.response_fields_value.map(field => JSON.stringify(field))
  //     record.addressed = JSON.stringify(record.addressed)
  //     Promise.all([value, responseValue]).then(result => {
  //         record.fields_value = result[0]
  //         record.response_fields_value = result[1]
  //         Axios.put("/requested-letters/save/"+record._id, record).then(() => {
  //             this.fetchLetters()
  //             this.sendMail(record)
  //         })
  //     })
  // }

  sendRejectedMail = async (record) => {
    const student = await Axios.get("/users/mahasiswa/" + record.requester);

    if (student.data.email) {
      Axios.post("/send-mail", {
        subject: "ASA USU - Penolakan Ajuan Permohonan Surat",
        message:
          "Mohon maaf, ajuan permohohonan Surat " +
          record.letters_name +
          " Anda telah ditolak dengan alasan <b>" +
          this.state.rejectionReason +
          "</b>. Silahkan kunjungi <a href='https://asa.usu.ac.id'>asa.usu.ac.id</a> untuk melakukan pengajuan lainnya.",
        email: student.data.email,
      });
    }
  };

  onRejectLetter = () => {
    let record = this.state.selectedRow;
    record.rejected_date = "1";
    record.rejected_reason = this.state.rejectionReason;
    record.step = "rejected";
    const value = (record.fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const responseValue = (record.response_fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const dopingDoji = (record.doping_doji || []).map((field) =>
      JSON.stringify(field)
    );
    record.addressed = JSON.stringify(record.addressed);
    record.thesis_detail = JSON.stringify(record.thesis_detail);
    const internshipMember = record.internship_member
      ? record.internship_member.map((field) => JSON.stringify(field))
      : [];
    Promise.all([value, responseValue, dopingDoji, internshipMember]).then(
      (result) => {
        record.fields_value = result[0];
        record.response_fields_value = result[1];
        record.doping_doji = result[2];
        record.internship_member = result[3];
        Axios.put("/requested-letters/save/" + record._id, record).then(() => {
          this.fetchLetters();
          this.sendRejectedMail(record.requester);
        });
      }
    );
    this.setState({ rejectModal: false, rejectionReason: "" });
  };

  handleRejectLetter = (record) => {
    this.setState({
      rejectModal: true,
      selectedRow: record,
      rejectionReason: "",
    });
  };

  handleChangeRejection = (e) => {
    this.setState({ rejectionReason: e.target.value });
  };

  render() {
    const columns = [
      {
        title: "NIM",
        dataIndex: "requester",
        sorter: true,
        ...searchColumns(
          "requester",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText
        ),
        render: (text) => (
          <Tooltip title="Biodata Mahasiswa">
            <Button type="link" onClick={() => this.fetchStudent(text)}>
              {text}
            </Button>
          </Tooltip>
        ),
      },
      {
        title: "Prodi",
        dataIndex: "major",
        sorter: true,
        render: (text) => text || <LoadingOutlined />,
      },
      {
        title: "Jenis Surat",
        dataIndex: "letters_name",
        sorter: true,
        // ...searchColumns('', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      // {
      //     title: 'Tipe Surat',
      //     dataIndex: 'letters_type',
      //     sorter: true,
      //     filters:  [
      //         { text: 'Akademik', value: 'akademik' },
      //         { text: 'Kemahasiswaan', value: 'kemahasiswaan' },
      //     ],
      //     filterMultiple: false,
      //     render: type => {
      //         const colors = {
      //             akademik : 'blue',
      //             kemahasiswaan : 'green',
      //         }
      //         return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>
      //     }
      // } ,
      {
        title: "Tanggal Diproses",
        dataIndex: "processed_date",
        sorter: true,
        render: (text) => (text ? moment(text).format("LLL") : "-"),
        // ...searchColumns('requester', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      {
        title: "Status",
        render: (row) => (
          <>
            <Tooltip title="Verifikasi">
              {row.addressed.identity ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip title="Upload/Tanda Tangani Surat Permohonan">
              {row.requested_file || row.signature ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip title="Kirim Surat Balasan">
              {row.send_response ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <CloseCircleOutlined style={{ color: "red" }} />
              )}
            </Tooltip>
          </>
        ),
      },
      {
        title: "Detail Surat",
        render: (record) => (
          <>
            <Link
              to={"/admin/surat/detail/" + record._id}
              style={{ margin: "0px auto" }}
            >
              <Button type="primary" shape="round" icon={<EditOutlined />}>
                {" "}
                Detail
              </Button>
            </Link>
          </>
        ),
      },
      {
        title: "",
        render: (record) => (
          <>
            <Tooltip title="Tolak" className="m-2">
              <Button
                shape="circle"
                type="danger"
                onClick={() => this.handleRejectLetter(record)}
                disabled={this.state.isReadOnly}
              >
                <CloseOutlined />
              </Button>
            </Tooltip>
          </>
        ),
      },
    ];

    return (
      <>
        <Row style={{ padding: 10 }}>
          <Table
            rowKey="_id"
            style={{ width: "100%" }}
            columns={columns}
            dataSource={this.state.letters}
            loading={this.props.loading}
            pagination={this.state.pagination}
            onChange={this.handleChangeTable}
          />
        </Row>

        <Modal
          title="Biodata Mahasiswa"
          visible={this.state.studentModal}
          footer={null}
          onCancel={this.toggleStudentModal}
        >
          <Skeleton active={true} loading={this.state.studentLoading}>
            <Row>
              <Col span={6} className="mr-1">
                <img
                  alt=""
                  src={this.state.student["FOTO"]}
                  style={{ objectFit: "cover", width: "100%" }}
                />
              </Col>
              <Col>
                <table>
                  <tbody>
                    <tr>
                      <td>Nama</td>
                      <td>: {this.state.student["nama"]}</td>
                    </tr>
                    <tr>
                      <td>NIM</td>
                      <td>: {this.state.student["nim"]}</td>
                    </tr>
                    <tr>
                      <td>Angkatan</td>
                      <td>: {this.state.student["angkatan"]}</td>
                    </tr>
                    <tr>
                      <td>Program Studi</td>
                      <td>: {this.state.student["program_studi"]}</td>
                    </tr>
                    <tr>
                      <td>Tempat Lahir</td>
                      <td>: {this.state.student["tempat_lahir"]}</td>
                    </tr>
                    <tr>
                      <td>Tanggal Lahir</td>
                      <td>
                        :{" "}
                        {moment(this.state.student["tanggal_lahir"]).format(
                          "ll"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>No. HP</td>
                      <td>: {this.state.student["no_hp_mahasiswa"]}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>: {this.state.student["email"]}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Skeleton>
          <Col className="mt-2">
            <h3>Riwayat Permohonan</h3>
            <Col>
              <Table
                rowKey="_id"
                dataSource={this.state.history}
                columns={[
                  {
                    title: "Tanggal Mengajukan",
                    dataIndex: "submitted_date",
                    render: (text) => moment(text).format("lll"),
                  },
                  {
                    title: "Jenis Surat",
                    dataIndex: "letters_name",
                  },
                  {
                    title: "Status",
                    dataIndex: "step",
                    render: (text) => {
                      const label = {
                        submitted: "DIAJUKAN",
                        processed: "DIPROSES",
                        finished: "SELESAI",
                        rejected: "DITOLAK",
                      };
                      return label[text] || "";
                    },
                  },
                ]}
                pagination={{
                  pageSize: 4,
                }}
              />
            </Col>
          </Col>
        </Modal>

        <Modal
          title="Tolak Permohonan"
          visible={this.state.rejectModal}
          okText="Ya"
          cancelText="Tidak"
          onOk={this.onRejectLetter}
          onCancel={() => this.setState({ rejectModal: false })}
        >
          <label>Alasan Penolakan</label>
          <TextArea
            onChange={this.handleChangeRejection}
            value={this.state.rejectionReason}
            placeholder="Masukkan Alasan Penolakan"
          />
        </Modal>
      </>
    );
  }
}

export default withErrorHandler(ProcessedLetters, Axios);
